import { Link, Navigate, Outlet, useLocation } from 'react-router-dom'

import { BrandLogo } from '@/components/BrandLogo'
import { useIsLoggedIn } from '@/stores/user'

export function AuthLayout() {
  const isLoggedIn = useIsLoggedIn()
  const location = useLocation()

  // Check if this is multi-account mode (allow logged in users to access login page)
  const searchParams = new URLSearchParams(location.search)
  const urlHasMultiAccount = searchParams.has('multi-account')
  // The sessionStorage flag only survives the OAuth redirect back to /login?code=...;
  // anywhere else it is a leftover from an abandoned "add account" flow
  const isOauthCallback = searchParams.has('code')
  const sessionHasMultiAccount = sessionStorage.getItem('isMultiAccountMode') === '1'
  const isMultiAccountMode = urlHasMultiAccount || (isOauthCallback && sessionHasMultiAccount)

  if (isLoggedIn && !isMultiAccountMode) {
    sessionStorage.removeItem('isMultiAccountMode')
    return <Navigate to="/" replace />
  }

  return (
    <div className="h-full flex flex-col bg-[image:var(--image-app-background)] bg-cover bg-no-repeat bg-center">
      <header className="p-4 fixed top-0 left-0 w-full z-10">
        <Link to="/" replace>
          <>
            <BrandLogo width={140} height={32} />
          </>
        </Link>
      </header>
      <main className="flex-grow flex items-center justify-center h-full overflow-y-auto">
        <Outlet />
      </main>
    </div>
  )
}
